module.exports = __webpack_public_path__ + "img/growcify-emzy-banner.6c6f9fb8.png";